import React, { useCallback, useEffect, useState } from 'react';

import { Link } from 'react-router-dom';

// import { useAuth } from '~/hooks/auth';
import { Realtime } from '~/services/firebase';
import IPayment from '~/interfaces/IPayment';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';

const Notifications: React.FC = () => {
  // const { user } = useAuth();
  // const { loadOrders } = useOrders();
  const [notifications, setNotifications] = useState<IPayment[]>([]);
  const [hasNewNotification, setHasNewNotification] = useState(false);

  const loadNotifications = useCallback(() => {
    const notificationsRef = Realtime.ref(`payments`);
    const startKey = notificationsRef.push().key;

    notificationsRef
      .orderByKey()
      .startAt(startKey)
      .on('child_added', data => {
        const value = {
          ...data.val(),
          uid: data.key,
        };

        setNotifications(current => [value, ...current]);
        setHasNewNotification(true);
        // loadOrders(user.uid);

        // tocar alarme
        // const audioEl: any =
        //   document.getElementsByClassName('audio-element')[0];
        // if (audioEl) {
        //   audioEl.play();
        // }

        const context = new AudioContext();
        const oscillator = context.createOscillator();

        oscillator.type = 'sine';
        oscillator.connect(context.destination);
        oscillator.start();

        setTimeout(() => {
          oscillator.stop();
        }, 3000);
      });
  }, []);

  useEffect(() => {
    loadNotifications();
  }, [loadNotifications]);

  return (
    <>
      <Link
        to="#notifications"
        className="dropdown-toggle nk-quick-nav-icon"
        data-toggle="dropdown"
      >
        <div
          className={hasNewNotification ? 'icon-status icon-status-info' : ''}
        >
          <em className="icon ni ni-bell" />
        </div>
        <audio className="audio-element" style={{ display: 'none' }}>
          <source src="./assets/alarm.mp3" />
        </audio>
      </Link>
      <div className="dropdown-menu dropdown-menu-xl dropdown-menu-right">
        <div className="dropdown-head">
          <span className="sub-title nk-dropdown-title">Notificações</span>
          {/* <Link to="#all">Mark All as Read</Link> */}
        </div>
        <div className="dropdown-body">
          <div className="nk-notification">
            {notifications.map(notification => (
              <Link
                to="/payments"
                className="nk-notification-item dropdown-inner"
                key={notification.uid}
              >
                <div className="nk-notification-icon">
                  <em className="icon icon-circle bg-primary-dim ni ni-invest" />
                </div>
                <div className="nk-notification-content">
                  <div className="nk-notification-text">
                    {`O cliente ${
                      notification.company_name
                    } realizou um pagamento via PIX no valor de ${getCurrencyFormatted(
                      notification.value,
                    )}`}
                  </div>
                  <div className="nk-notification-time">
                    {notification.created_at}
                  </div>
                </div>
              </Link>
            ))}
            {/* <div className="nk-notification-item dropdown-inner">
            <div className="nk-notification-icon">
              <em className="icon icon-circle bg-info-dim ni ni-edit" />
            </div>
            <div className="nk-notification-content">
              <div className="nk-notification-text">
                Iliash <span>invited</span> you to edit <span>DashLite</span>{' '}
                folder
              </div>
              <div className="nk-notification-time">2 hrs ago</div>
            </div>
          </div>
          <div className="nk-notification-item dropdown-inner">
            <div className="nk-notification-icon">
              <em className="icon icon-circle bg-primary-dim ni ni-share" />
            </div>
            <div className="nk-notification-content">
              <div className="nk-notification-text">
                You have shared <span>project v2</span> with Parvez.
              </div>
              <div className="nk-notification-time">7 days ago</div>
            </div>
          </div>
          <div className="nk-notification-item dropdown-inner">
            <div className="nk-notification-icon">
              <em className="icon icon-circle bg-success-dim ni ni-spark" />
            </div>
            <div className="nk-notification-content">
              <div className="nk-notification-text">
                Your <span>Subscription</span> renew successfully.
              </div>
              <div className="nk-notification-time">2 month ago</div>
            </div>
          </div> */}
          </div>
        </div>
        {notifications.length === 0 && (
          <div className="dropdown-foot center">
            Você não possui notificações.
          </div>
        )}
      </div>
    </>
  );
};

export default Notifications;
